import logger from '@cash-web/shared/util-logger'
import { HttpError } from '@cash-web/shared-util-fetch'

type StatusComponent = {
  name: string
  status: string
}

export type StatusPageResponse = {
  components: StatusComponent[]
}

const statusPageApiUrl =
  process.env['NEXT_PUBLIC_STATUS_PAGE_API_URL'] || 'https://crz5fygf73g7.statuspage.io/api/v2/components.json'

export async function getStatusPage(signal?: AbortSignal): Promise<StatusPageResponse> {
  try {
    const response = await fetch(statusPageApiUrl, {
      method: 'GET',
      signal,
      credentials: 'omit', // Don't send cookies to third-party API
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        Accept: 'application/json',
      },
    })

    if (response.ok) {
      return response.json()
    } else {
      const body = await response.text()
      throw new HttpError(body, response.status, body)
    }
  } catch (error) {
    logger.error(new Error(`Failed to fetch status page, error: ${error}`))
    return { components: [] }
  }
}
